var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.7881C6.07 22.7881 1.25 17.9681 1.25 12.0381C1.25 6.10809 6.07 1.28809 12 1.28809C17.93 1.28809 22.75 6.10809 22.75 12.0381C22.75 17.9681 17.93 22.7881 12 22.7881ZM12 2.78809C6.9 2.78809 2.75 6.93809 2.75 12.0381C2.75 17.1381 6.9 21.2881 12 21.2881C17.1 21.2881 21.25 17.1381 21.25 12.0381C21.25 6.93809 17.1 2.78809 12 2.78809Z",
    fill: "#92A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5799 15.6181C10.3799 15.6181 10.1899 15.5381 10.0499 15.3981L7.21994 12.5681C6.92994 12.2781 6.92994 11.7981 7.21994 11.5081C7.50994 11.2181 7.98994 11.2181 8.27994 11.5081L10.5799 13.8081L15.7199 8.66806C16.0099 8.37806 16.4899 8.37806 16.7799 8.66806C17.0699 8.95806 17.0699 9.43806 16.7799 9.72806L11.1099 15.3981C10.9699 15.5381 10.7799 15.6181 10.5799 15.6181Z",
    fill: "#92A1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.0e5f5815c995eb7758470e29dd0bc392.svg";
export { ForwardRef as ReactComponent };